// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hX7CrMRcEuCoNj {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--ds-space-300, 24px);
  background-color: var(--ds-background-accent-yellow-subtlest, rgba(255, 250, 229, 0.4));
  text-align: left;
  gap: var(--ds-space-200, 14px);
}
.XMuoQ7od8ZRJZw {
  padding: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-050, 4px) var(--ds-space-075, 6px);
}
.XMuoQ7od8ZRJZw svg {
  width: auto;
  height: 16px;
}
.XMuoQ7od8ZRJZw svg path {
  fill: var(--ds-background-accent-yellow-subtle, #ffc400);
}
.mDvaQjSWUQlJg7 {
  display: flex;
  padding-bottom: var(--ds-space-075, 6px);
  line-height: 16px;
}
.R0KCkZ9wbB7wn2 {
  padding-right: var(--ds-space-050, 4px);
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  font-weight: var(--ds-font-weight-regular, normal);
  line-height: 20px;
}
.d25DM6AdthzI2L {
  margin-bottom: var(--ds-space-200, 14px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
}
.H20ebr7TGoBQQw {
  display: inline-block;
}
.H20ebr7TGoBQQw a,
.H20ebr7TGoBQQw > span {
  display: inline-flex;
  align-items: center;
  padding: var(--ds-space-150, 12px) var(--ds-space-200, 14px) var(--ds-space-150, 12px);
  transition: all 250ms ease-out;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-100, 4px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
}
.H20ebr7TGoBQQw a span,
.H20ebr7TGoBQQw > span span {
  display: inline-block;
}
.H20ebr7TGoBQQw a svg,
.H20ebr7TGoBQQw > span svg {
  display: inline-block;
  margin-top: var(--ds-space-025, 2px);
  margin-left: var(--ds-space-100, 8px);
  transform: translate3d(0px, 0, 0);
  transition: transform 250ms ease-out;
}
.hX7CrMRcEuCoNj div > a {
  padding: var(--ds-space-150, 12px) var(--ds-space-200, 14px);
  border: 1px solid var(--ds-border-accent-yellow, #ffc400);
  background-color: var(--ds-background-input, #ffffff);
  font-size: 16px;
  line-height: 24px;
}
.hX7CrMRcEuCoNj div > a > span {
  color: var(--ds-text, #172b4d);
}
.H20ebr7TGoBQQw a:hover,
.H20ebr7TGoBQQw > span:hover {
  border-color: var(--ds-border, #091e4224);
  background-color: var(--ds-background-accent-gray-bolder, rgba(137, 147, 164, 0.1));
  text-decoration: none;
}
.H20ebr7TGoBQQw a:hover svg,
.H20ebr7TGoBQQw > span:hover svg {
  transform: translate3d(3px, 0, 0);
}
.H20ebr7TGoBQQw a:active,
.H20ebr7TGoBQQw > span:active {
  border-color: var(--ds-border, #091e4224);
  background-color: var(--ds-background-accent-gray-subtler, rgba(122, 134, 154, 0.1));
  color: var(--ds-text-subtlest, #626f86);
}
.H20ebr7TGoBQQw a:focus,
.H20ebr7TGoBQQw > span:focus {
  box-shadow: 0 0 0 4px var(--ds-background-accent-gray-subtle, rgba(137, 147, 164, 0.4));
}
.hX7CrMRcEuCoNj div > a:hover {
  border: 1px solid var(--ds-border-accent-yellow, #ffc400);
  background-color: var(--ds-background-accent-yellow-subtler, #fffae5);
}
.hX7CrMRcEuCoNj div > a:active {
  border: 1px solid var(--ds-border-accent-yellow, #ffc400);
  background-color: var(--ds-background-accent-yellow-subtler, #fffae5);
}
.hX7CrMRcEuCoNj div > a:focus {
  border: 1px solid var(--ds-border-accent-yellow, #ffc400);
  background-color: var(--ds-background-accent-yellow-subtler, #fffae5);
}
`, ""]);
// Exports
export var banner = `hX7CrMRcEuCoNj`;
export var bannerIcon = `XMuoQ7od8ZRJZw`;
export var bannerTitleContainer = `mDvaQjSWUQlJg7`;
export var bannerTitle = `R0KCkZ9wbB7wn2`;
export var bannerDescription = `d25DM6AdthzI2L`;
export var linkButton = `H20ebr7TGoBQQw`;
export default ___CSS_LOADER_EXPORT___;
